<div class="modal fade" id="dialogHistoricoFavorecido" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-info text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">
          <em class="fa fa-history"></em> Históricos do Beneficiário
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-8">
                <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
                </lib-filtro>
              </div>
              <div class="col-md-4">
                <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
                  (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
              </div>
            </div>
          </div>
          <div class="card-body p-0">
            <table class="table table-eddy">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-center">Data</th>
                  <th scope="col" class="text-center">Empenho</th>
                  <th scope="col">Histórico</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of lista">
                  <td class="text-center">{{item.data_empenho | date:'dd/MM/yyyy':'GMT'}}</td>
                  <td class="text-center">{{("00000" + item.numero).slice(-5) }}</td>
                  <td>{{item.historico}}</td>
                  <td>
                    <button class="btn btn-sm btn-outline-primary" (click)="importarHistorico(item.historico)">
                      <img src="assets/img/global/text_imports.png" title="Importar histórico" alt="Importar histórico"
                        height="16" width="16">
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>